(function () {
  const TARGET_PATH = "/collections/conversions";
  if (location.pathname !== TARGET_PATH) return;

  const DEFAULT_YEAR_TEXT = "2026";
  const DEFAULT_MODEL_TEXT = "Gladiator (JT)";

  // Don’t override if user already has selections (or app has "keep filtering"/garage saved)
  function isPlaceholderSelected(selectEl) {
    const v = (selectEl.value || "").trim();
    const t = (selectEl.options[selectEl.selectedIndex]?.text || "").trim().toLowerCase();
    return !v || t.includes("select year") || t.includes("select model") || t.includes("select");
  }

  function setSelectByOptionText(selectEl, desiredText) {
    const desired = desiredText.trim().toLowerCase();
    const opts = Array.from(selectEl.options);
    const match = opts.find(o => (o.text || "").trim().toLowerCase() === desired);
    if (!match) return false;

    // Only set if still placeholder
    if (!isPlaceholderSelected(selectEl)) return true;

    selectEl.value = match.value;
    // Fire change so EasySearch updates results
    selectEl.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function findYearAndModelSelects() {
    // Common pattern: two <select> elements near text "Year" and "Model"
    // We’ll scan selects and infer which is which by nearby text.
    const selects = Array.from(document.querySelectorAll("select"));
    if (selects.length < 2) return null;

    let yearSel = null;
    let modelSel = null;

    for (const sel of selects) {
      const parentText = (sel.parentElement?.innerText || "").toLowerCase();
      const aria = (sel.getAttribute("aria-label") || "").toLowerCase();
      const name = (sel.getAttribute("name") || "").toLowerCase();
      const id = (sel.id || "").toLowerCase();

      const hint = `${parentText} ${aria} ${name} ${id}`;

      if (!yearSel && hint.includes("year")) yearSel = sel;
      if (!modelSel && hint.includes("model")) modelSel = sel;
    }

    // Fallback: if we didn’t detect labels, just take first two
    if (!yearSel || !modelSel) {
      const firstTwo = selects.slice(0, 2);
      yearSel = yearSel || firstTwo[0];
      modelSel = modelSel || firstTwo[1];
    }

    return { yearSel, modelSel };
  }

  function tryApplyDefaults() {
    const found = findYearAndModelSelects();
    if (!found) return false;

    const { yearSel, modelSel } = found;

    const yearOk = setSelectByOptionText(yearSel, DEFAULT_YEAR_TEXT);
    // model options might not populate until year is chosen—try in a moment too
    setTimeout(() => setSelectByOptionText(modelSel, DEFAULT_MODEL_TEXT), 150);

    return yearOk;
  }

  // Try immediately + observe for app-rendered DOM updates
  if (tryApplyDefaults()) return;

  const obs = new MutationObserver(() => {
    if (tryApplyDefaults()) obs.disconnect();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Safety stop
  setTimeout(() => obs.disconnect(), 8000);
})();